import React from "react";
import { withRefluxStore } from "../../../../../../Stores";
import { ActionsDataViz } from "../../../../../../Actions/ActionsDataViz/ActionsDataViz";
import DataVizStore from "../../../../../../Stores/DataVizStore";

import * as SC from "./CardHeaderOptions.styled";

const CardHeaderOptions = ({
  options,
  channels,
  cardKey,
  emitEventTracking,
  // Store
  selectedChannel,
  selectedOptions
}) => {
  const hasOptions = Boolean(options.length > 0);
  const hasChannels = Boolean(channels.length > 0);

  const emitSelectChannel = ({ value }) => {
    emitEventTracking("Button Clicked", { channelSelected: value });

    const currentSelectedChannel = selectedChannel[cardKey];
    const newChannel = currentSelectedChannel === value ? null : value;

    ActionsDataViz.selectChannel(newChannel, cardKey);
  };

  const emitSelectOption = ({ option }) => {
    emitEventTracking("Button Clicked", { optionSelected: option });
    const currentSelectedOption = selectedOptions[cardKey];
    const newOption = currentSelectedOption === option ? "ctr" : option;

    ActionsDataViz.selectOptions(newOption, cardKey);
  };

  const renderChannels = () => {
    return channels.map((channel, index) => (
      <SC.OptionsChannels key={channel} onClick={() => emitSelectChannel({ value: channel })}>
        <SC.ChannelIcon selectedChannel={selectedChannel[cardKey]} currentChannel={channel}>
          <SC.ChannelDot
            selectedChannel={selectedChannel[cardKey]}
            currentChannel={channel}
            index={index}
          />
          <p>{channel}</p>
        </SC.ChannelIcon>
      </SC.OptionsChannels>
    ));
  };

  const renderOptions = () => {
    return options.map(({ label, value }) => (
      <SC.StringOption
        key={value}
        onClick={() => emitSelectOption({ option: value })}
        isSelected={selectedOptions[cardKey] === value}
      >
        {label}
      </SC.StringOption>
    ));
  };

  // Target Performance
  if (hasOptions && hasChannels && cardKey === "performanceMetrics") {
    const defaultOption = { value: "allChannelsAverage", label: "All Channels" };
    const mappedOptions = channels.map((channel) => ({ value: channel, label: channel }));
    mappedOptions.push(defaultOption);

    return (
      <SC.OptionsWrapper>
        <SC.Options isStringOptions>{renderOptions()}</SC.Options>
        <SC.Options>
          <SC.ChannelList
            defaultValue={defaultOption}
            options={mappedOptions}
            onChange={emitSelectChannel}
            styles={SC.ControlReactSelect}
          />
        </SC.Options>
      </SC.OptionsWrapper>
    );
  }

  // OR Interaction
  return (
    <SC.OptionsWrapper>
      <SC.Options>{hasChannels && renderChannels()}</SC.Options>
      <SC.Options isStringOptions>{hasOptions && renderOptions()}</SC.Options>
    </SC.OptionsWrapper>
  );
};

export default withRefluxStore(
  CardHeaderOptions,
  [DataVizStore],
  ["selectedChannel", "selectedOptions"]
);
